<template>
  <div>
    <div class="" v-if="!isDataFetched">
      <div class="loader">
        <base-loader/>
      </div>
    </div>
    <div class="container">
      <h1>Account Info</h1>
      <p>
        Visit the
        <router-link to="/system/billing">
          Billing page
        </router-link>
        to update info or change your subscription
      </p>
      <div class="table">
        <div class="table-row">
            <label>
                Organization Name
            </label>
            <input :class="{ error: errorFields.name }" v-model="agencyData.name" @change="updateAgency"/>
        </div>
        <div class="table-row">
            <label>
                Email
            </label>
            <input :class="{ error: errorFields.email }" v-model="agencyData.email" @change="updateAgency"/>
        </div>
        <div class="table-row">
            <label>
                Projects
            </label>
            <span class="row-span">{{  agencyData.project_count }}</span>
            <!-- <router-link target="_blank" class="link" :to="{ name: 'clients'}">{{  agencyData.project_count }}</router-link> -->
        </div>
        <div class="table-row">
            <label>
                Users
            </label>
            <router-link target="_blank" class="link" :to="{ name: 'user_manager'}">{{  agencyData.user_count }}</router-link>
        </div>
        <div class="table-row">
            <label>
                Keywords 
            </label>
            <span class="row-span">{{  agencyData.keyword_count }}</span>
            <!-- <router-link target="_blank" class="link" :to="{ name: 'keyword-census'}">{{  agencyData.keyword_count }}</router-link> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import ToasterService from '@/services/toasterService'

export default {
  name: 'AccountInfo',
  data () {
    return {
      isDataFetched: false,
      isDataUpdating: false,
      disableButtons: false,
      errorFields: {
        name: false,
        email: false
      }
    }
  },
  watch: {
    clientId: {
      handler(v) {
        if (v) {
          this.isDataFetched = false
          this.getAgency({ clientId: v }).then(() => {
            this.isDataFetched = true
          })
        }
      },
      immediate: true
    }
  },
  async mounted() {
    await this.getAgency({ clientId: this.clientId })
    this.isDataFetched = true
  },
  computed: {
    ...mapState('agency', ['agencyData', 'billingData']),
  },
  methods: {
    ...mapActions('agency', ['getAgency', 'updateAgencyData']),
    ...mapActions(['getCurrentSession', 'updateSelectedClientData']),
    resetErrors () {
      for (const k in this.errorFields) {
        this.errorFields[k] = false
      }
    },
    async updateAgency () {
      this.resetErrors()
      const response = await this.updateAgencyData({
        clientId: this.clientId,
        id: this.agencyData.id,
        name: this.agencyData.name,
        email: this.agencyData.email
      })
      if (response.errors) {
        response.errors.forEach(err => {
          this.errorFields[err.field] = true
          ToasterService.showToast(ToasterService.ERROR_TYPE, err.message)

        })
      }
    },
  }
}
</script>

<style scoped lang="scss">

    .container {
      display: flex;
      flex-direction: column;
      margin: 0 15vw;
    }
    
    h1 {
    }
    .table {
        margin: 5vh 0;
        border-top: 1px solid $rfx-light-steel;
        border-right: 1px solid $rfx-light-steel;
        border-left: 1px solid $rfx-light-steel;
        display: flex;
        flex-direction: column;
        background-color: #FFF;
        border-radius: $rfx-default-border-radius;
        padding: 0;
    }
    .table-row {
        height: 5vh;
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid $rfx-light-steel;
    }
    label {
        border-right: 1px solid $rfx-light-steel;
        width: 50%;
        padding: 10px 20px;
        color: $rfx-dark-march;
        font-weight: bold;
    }
    input {
        padding: 0 20px;
        border: none;
        outline: none;
        width: 50%;
    }
    input:disabled {
      background-color: inherit;
    }

    input.error {
      background-color: #ffdddd;
    }
    .row-span {
      width: 50%;
      padding: 10px 20px;
    }
    .link {
      text-decoration: none;
      color: $rfx-bright-blue;
      cursor: pointer;
      width: 50%;
      padding: 10px 20px;
    }
    .loader {
      display: flex;
      position: fixed;
      padding-top: 20vh;
      width: 100%;
      justify-content: center;
      align-items: flex-start;
      height: 100vh;
      background-color: rgba(255, 255, 255, .7);
    }
</style>
